export default __webpack_public_path__ + "static/media/closet2.2490148c.jpg";